import React, { useContext } from 'react'
import { Link } from 'gatsby'

import StoreContext from '~/context/StoreContext'
import { GetPrice } from '~/utils/helpers'
import {
  Wrapper,
  ImageContainer,
  Remove,
  Meta,
  Price,
  Increment,
  Decrement,
} from './styles'
import { CartCounter } from '~/components/Navigation/styles'

const LineItem = props => {
  const { item } = props
  const {
    updateLineItem,
    store: { client, checkout },
  } = useContext(StoreContext)

  const variantImage = item.variant.image ? (
    <img
      src={item.variant.image.src}
      alt={`${item.title} product shot`}
      height="60px"
    />
  ) : null

  const handleUpdateQuantity = quantity => {
    updateLineItem(client, checkout.id, item.id, quantity)
  }

  const isWholesale = item.title.indexOf('Wholesale') === 0

  return (
    <Wrapper>
      <Link to={`/products/${item.variant.product.handle}/`}>
        <ImageContainer>{variantImage}</ImageContainer>
      </Link>
      <Meta>
        <Link to={`/products/${item.variant.product.handle}/`}>
          <h3>
            {item.title.replace(' Snack Bar', '')}{' '}
            {item.variant.title !== 'Default Title' ? (
              <div className="variant">{item.variant.title}</div>
            ) : (
              ''
            )}
          </h3>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Price>
              {isWholesale && 'Box 15 – '}
              {GetPrice(item.variant.price)}
            </Price>
          </div>
        </Link>
      </Meta>
      <Remove>
        <Decrement
          onClick={() => {
            handleUpdateQuantity(item.quantity - 1)
          }}
        ></Decrement>

        <CartCounter style={{ backgroundColor: '#dcd0af', color: '#211f15' }}>
          {item.quantity}
        </CartCounter>

        <Increment
          onClick={() => {
            handleUpdateQuantity(item.quantity + 1)
          }}
        ></Increment>
      </Remove>
    </Wrapper>
  )
}

export default LineItem
